import TheatreRoomEvents from './Components/TheatreRoomEventsList'

export default TheatreRoomEvents
